export const font = '"DM Sans", sans-serif';

export const FUNNEL_STAGES = [
  { id: "awareness", label: "Awareness", icon: "👁", desc: "Top-of-funnel: brand visibility and recall.", example: "e.g. 'What do you know about E.ON?'" },
  { id: "consideration", label: "Consideration", icon: "🤔", desc: "Mid-funnel: comparison and preference.", example: "e.g. 'Compare E.ON vs. Vattenfall for home energy.'" },
  { id: "purchase_intent", label: "Purchase Intent", icon: "🛒", desc: "Bottom-of-funnel: readiness to buy.", example: "e.g. 'Best energy tariff for a new homeowner?'" },
];

export const LLM_PLATFORMS = [
  { id: "chatgpt", label: "ChatGPT", provider: "OpenAI", color: "#10a37f", available: true },
  { id: "claude", label: "Claude", provider: "Anthropic", color: "#d97706", available: true },
  { id: "gemini", label: "Gemini", provider: "Google", color: "#4285f4", available: true },
  { id: "perplexity", label: "Perplexity", provider: "Perplexity", color: "#1a1a2e", available: true },
];

export const DEFAULT_LLM_PLATFORM_IDS = LLM_PLATFORMS.map((p) => p.id);

/** Simulation `status` values that mean queries/results can be shown.
 *  7 = translation completed (pipeline). 10 = saved. */
export const QUERY_READY_STATUSES = [4, 5, 6, 7, 10, 90, 91];
export const ANALYSIS_DONE_STATUSES = [6, 7, 10, 91];

/** Fallback colors for brand names in charts; add entries as needed or leave empty for default gray */
export const BRANDS_COLORS = {};

/** The 54 markets GWI Core covers. A market outside this list has no audience data,
 *  so the simulation is rejected before it starts instead of profiling the wrong country. */
export const COUNTRY_OPTIONS = [
  'Argentina', 'Australia', 'Austria', 'Belgium', 'Brazil', 'Bulgaria',
  'Canada', 'Chile', 'China', 'Colombia', 'Croatia', 'Czech Republic',
  'Denmark', 'Egypt', 'France', 'Germany', 'Ghana', 'Greece',
  'Hong Kong', 'Hungary', 'India', 'Indonesia', 'Ireland', 'Israel',
  'Italy', 'Japan', 'Kenya', 'Malaysia', 'Mexico', 'Morocco',
  'Netherlands', 'New Zealand', 'Nigeria', 'Norway', 'Philippines', 'Poland',
  'Portugal', 'Romania', 'Russia', 'Saudi Arabia', 'Serbia', 'Singapore',
  'South Africa', 'South Korea', 'Spain', 'Sweden', 'Switzerland', 'Taiwan',
  'Thailand', 'Turkey', 'United Arab Emirates', 'United Kingdom', 'United States', 'Vietnam',
].sort();

/** Keep a project's stored country selectable even if it is not a GWI market,
 *  so opening the edit dialog does not silently clear the field. */
export const countryOptionsWith = (current) => {
  const value = (current ?? '').trim();
  if (!value || COUNTRY_OPTIONS.includes(value)) return COUNTRY_OPTIONS;
  return [value, ...COUNTRY_OPTIONS];
};


export const LANGUAGES = [
  "English","German","French","Spanish","Portuguese","Italian","Dutch","Polish","Russian","Ukrainian",
  "Czech","Slovak","Romanian","Bulgarian","Croatian","Serbian","Slovenian","Hungarian","Swedish","Danish",
  "Norwegian","Finnish","Estonian","Latvian","Lithuanian","Greek","Turkish","Arabic","Hebrew","Persian","Urdu","Hindi",
  "Bengali","Tamil","Telugu","Marathi","Gujarati","Kannada","Malayalam","Punjabi","Nepali","Sinhala","Thai","Vietnamese",
  "Indonesian","Malay","Filipino (Tagalog)","Burmese (Myanmar)","Khmer","Lao",
  "Chinese (Simplified)","Chinese (Traditional)","Japanese","Korean","Mongolian","Georgian","Armenian","Azerbaijani","Kazakh","Uzbek",
  "Swahili","Amharic","Hausa","Yoruba","Igbo","Zulu","Afrikaans","Catalan","Galician","Basque","Welsh",
  "Irish","Icelandic","Maltese","Luxembourgish","Albanian","Macedonian","Bosnian","Latin"
].sort().filter((c, i, arr) => arr.indexOf(c) === i);
